import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHouse,
  faBullseye,
  faChartLine,
  faCalendarCheck,
} from '@fortawesome/free-solid-svg-icons';
import styles from '../../styles/LandingPage.module.css';

// Define your nav sections & icons here:
const sections = ['home', 'contact'];
const NAV_ICONS = {
  home: faHouse,
  services: faBullseye,
  results: faChartLine,
  contact: faCalendarCheck,
};

export default function BottomNav({ active, onNav }) {
  return (
    <nav className={styles.heroNav}>
      <ul>
        {sections.map((id) => (
          <li key={id} data-anim>
            <button
              className={active === id ? styles.cur : undefined}
              onClick={() => onNav(id)}
              aria-label={id}
            >
              <FontAwesomeIcon className={styles.navIcons} icon={NAV_ICONS[id]} />
              <span className={styles.navLabel}>
                {id === 'home' ? 'Home' : id.charAt(0).toUpperCase() + id.slice(1)}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
